import React from 'react';
import CatalogoP from '../catalagobase/catalogobase';
import Navbar from '../../components/navbar/navbar';
import Sidebar from '../../components/sidebar/sidebar';
import { API_URLS } from '../../Services/servicioURL';
import { InputText } from 'primereact/inputtext';

function Departamento() {
    return (
        <div>

            <Navbar />
            <Sidebar />
            <CatalogoP title="Departamentos" apiUrls={API_URLS.departamentos}/>
            
            <div className="FormABC-content">
                            <form autoComplete="off">
                                <div className="grid">
                                   
                                </div>
                            </form>
                        </div>          
           </div>
    );     
        
    }

export default Departamento;

